import { PrimitiveType, FormatXMLElementFn } from 'intl-messageformat';
import moment, { isMoment } from 'moment'
import { ReactElement, JSXElementConstructor, ReactNodeArray } from 'react';
import { MessageDescriptor } from 'react-intl';
import {getLocale} from "umi";

export const getHourTime = (time:string) => {
    if (time?.split(':')?.length < 3) {
        return (time || '00:00') + ':00'
    } else {
        return time
    }
}

export const getUTc = () => {
    const nowTime = new Date()?.toString()
    const GTMIndex = nowTime.indexOf('GMT')
    const GTM:any = nowTime.substring(GTMIndex + 3, GTMIndex + 6) - 0 || ('+08' - 0)
    const dUTC = 8 - GTM
    return dUTC
}

// 当前用户时区转换成东八区时间
export const formatUTC8Time = (time:string) => {
    const isMomentType = isMoment(time)
    return isMomentType ? time.utcOffset(8).format('YYYY-MM-DD HH:mm:ss') : moment(time).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')
}

export const getUTCTime = (time:string) => {
    if (time === '') return time
    // 获取当前用户时区
    const nowTime = new Date()?.toString()
    const GTMIndex = nowTime.indexOf('GMT')
    const GTM = (nowTime.substring(GTMIndex + 3, GTMIndex + 6) + '00') || '+0800'
    const GTMM = GTM?.slice(0, 2) + ':' + GTM?.slice(2) || '+08:00'
    // 获取传入时间转换东八区时间
    const GTMTime = new Date(time)?.toString()
    let UTC8Time
    UTC8Time = GTMTime?.replace(GTM, '+0800')
    UTC8Time = UTC8Time?.replace(GTMM, '+08:00')
    return moment(UTC8Time ?? time).utcOffset(GTM).format('YYYY-MM-DD HH:mm:ss') === 'Invalid date' ? time : moment(UTC8Time ?? time).utcOffset(GTM).format('YYYY-MM-DD HH:mm:ss')
}


export const getFreq = (frequncyParams: { frequency_interval: any; frequency_time: any; }, type: number) => {
    const { frequency_interval, frequency_time } = frequncyParams
    let freqDay
    let freqTime
    const dUTC = getUTc() || 0
    try {
        if (type == 1) {
            freqDay = ''
            freqTime = '00:00:00'
        } else if (type == 2) {
            const frequncyTime = formatUTC8Time(moment(frequency_interval + ' ' + getHourTime(frequency_time)).format('YYYY-MM-DD HH:mm:ss'))
            freqDay = moment(frequncyTime).format('YYYY-MM-DD')
            freqTime = moment(frequncyTime).format('HH:mm:ss')
        } else if (type == 3) {
            const frequncyTime = frequency_interval?.split(',')?.map((item: any) => {
                let time = Number(item) + dUTC
                if (time < 0) {
                    time = 24 + time
                } else if (time >= 24) {
                    time = time - 24
                }
                return time
            })
            freqDay = frequncyTime?.join(',') || frequency_interval
            freqTime = '00:00:00'
        } else if (type == 4) {
            freqDay = ''
            let { freqTime: dayFreqTime } = getDayWeekMonth(frequncyParams)
            freqTime = dayFreqTime
        } else if (type == 5) {
            let { freqDay: weekFreqDay, freqTime: weekFreqTime } = getDayWeekMonth(frequncyParams)
            freqDay = weekFreqDay
            freqTime = weekFreqTime
        } else if (type == 6) {
            let { freqDay: monthFreqDay, freqTime: monthFreqTime } = getDayWeekMonth(frequncyParams, true)
            freqDay = monthFreqDay
            freqTime = monthFreqTime
        } else {
            freqDay = frequency_interval
            freqTime = frequency_time
        }
        return {
            freqDay,
            freqTime
        }
    } catch (error) {
        return { freqDay: frequency_interval, freqTime: frequency_time }
    }
}

export const getDayWeekMonth = (frequncyParams: { frequency_time: any; frequency_interval?: any; }, isMonth = false, isChange = false) => {
    const { frequency_interval, frequency_time } = frequncyParams
    let freqDay
    let freqTime
    let dUTC = getUTc() || 0
    if (isChange) dUTC = -dUTC
    freqDay = frequency_interval
    try {
        const frequncyTime = frequency_time?.split(':')
        let time = Number(frequncyTime[0]) + dUTC
        if (time < 0) {
            time = 24 + time
            const frequncyTime = frequency_interval?.split(',')?.map((item: number) => {
                item = item - 0
                return isMonth ? item - 1 === 0 ? 31 : item - 1 : item - 1 === 0 ? 7 : item - 1
            })
            freqDay = frequncyTime?.join(',') || frequency_interval
        } else if (time >= 24) {
            time = time - 24
            const frequncyTime = frequency_interval?.split(',')?.map((item: number) => {
                item = item - 0
                return isMonth ? item === 31 ? 1 : item + 1 : item === 7 ? 1 : item + 1
            })
            freqDay = frequncyTime?.join(',') || frequency_interval
        }
        frequncyTime[0] = time?.toString()?.length === 2 ? time?.toString() : `0${time}`
        freqTime = frequncyTime?.join(',')?.replace(/,/g, ':') || frequency_time
        return {
            freqDay,
            freqTime
        }
    } catch (error) {
        return { freqDay: frequency_interval, freqTime: frequency_time }
    }
}

// 小时推送频率东八区转用户时区
export const getHUTC8Frequency = (frequency_interval: string) => {
    const dUTC = getUTc() || 0
    const frequncyTime = frequency_interval?.split(',')?.map((item: any) => {
        let time = Number(item) - dUTC
        if (time < 0) {
            time = 24 + time
        } else if (time >= 24) {
            time = time - 24
        }
        return time
    })
    const freqDay = frequncyTime?.join(',') || frequency_interval
    return freqDay
}

// 编辑页面东八区转换为用户时区
export const getEditFrequency = (formValueQuery: { frequency: any; cycle: any; }) => {
    const { frequency, cycle } = formValueQuery
    try {
        let newCycle = [getUTCTime(`${cycle?.[0]} 00:00:00`), getUTCTime(`${cycle?.[1]} 23:59:59`)]
        newCycle = [moment(newCycle[0]).format('YYYY-MM-DD'), moment(newCycle[1]).format('YYYY-MM-DD')]
        const newFrequency = utc8To(frequency)
        formValueQuery.frequency = newFrequency ?? frequency
        formValueQuery.cycle = newCycle ?? cycle
    } catch (error) { }
    return formValueQuery
}

const utc8To = (frequency: { frequency_interval: any; frequency_time: any; type: any; }) => {
    const { frequency_interval, frequency_time, type } = frequency
    let freqDay = frequency_interval
    let freqTime = frequency_time
    switch (type) {
        case 2: {
            const frequncyTime = getUTCTime(frequency_interval + ' ' + frequency_time)
            freqDay = moment(frequncyTime).format('YYYY-MM-DD')
            freqTime = moment(frequncyTime).format('HH:mm:ss')
            break;
        }
        case 3: {
            freqTime = '00:00:00'
            const dUTC = getUTc() || 0
            freqDay = frequency_interval?.map((item: any) => {
                let time = Number(item) - dUTC
                if (time < 0) {
                    time = 24 + time
                } else if (time >= 24) {
                    time = time - 24
                }
                return time + ''
            })
            break;
        }
        case 4: {
            const { freqTime: dayFreqTime } = getDayWeekMonth({ frequency_time }, false, true)
            freqTime = dayFreqTime
            break;
        }
        case 5: {
            const newFrequency_interval = typeof frequency_interval === 'string' ? frequency_interval : frequency_interval?.join(',')
            const { freqTime: weekFreqTime, freqDay: weekFreqDay } = getDayWeekMonth({ frequency_interval: newFrequency_interval, frequency_time }, false, true)
            freqTime = weekFreqTime
            freqDay = typeof weekFreqDay === 'string' ? weekFreqDay?.split(',') : weekFreqDay
            break;
        }
        case 6: {
            const newFrequency_interval = typeof frequency_interval === 'string' ? frequency_interval : frequency_interval?.join(',')
            const { freqTime: monthFreqTime, freqDay: monthFreqDay } = getDayWeekMonth({ frequency_interval: newFrequency_interval, frequency_time }, true, true)
            freqTime = monthFreqTime
            freqDay = typeof monthFreqDay === 'string' ? monthFreqDay?.split(',') : monthFreqDay
            break;
        }
        default: break;
    }
    return {
        frequency_interval: freqDay,
        frequency_time: freqTime,
        type
    }
}


// 获取频率字符串
export const getFrequencyStr = (record: any, formatMessage: { (descriptor: MessageDescriptor, values?: Record<string, PrimitiveType> | undefined): string; (descriptor: MessageDescriptor, values?: Record<string, PrimitiveType | ReactElement<any, string | JSXElementConstructor<any>> | FormatXMLElementFn> | undefined): string | ReactNodeArray; (arg0: { id: string; }): any; }, WEEK_TEXT: { [x: string]: any; 1?: string; 2?: string; 3?: string; 4?: string; 5?: string; 6?: string; 7?: string; }, TIME_TEXT: { [x: string]: any; 0?: string; 1?: string; 2?: string; 3?: string; 4?: string; 5?: string; 6?: string; 7?: string; 8?: string; 9?: string; 10?: string; 11?: string; 12?: string; 13?: string; 14?: string; 15?: string; 16?: string; 17?: string; 18?: string; 19?: string; 20?: string; 21?: string; 22?: string; 23?: string; }) => {
  switch (record?.frequency_type) {
    // 无效
    case 0: return formatMessage({id: "subscribe_manager_frequency_invalid"})
    // 立即发送
    case 1: return formatMessage({id: "subscribe_manager_frequency_push_now"})
    // 单次
    case 2: return formatMessage({id: "subscribe_manager_frequency_single"});
    // 小时
    case 3: return getHUTC8Frequency(record?.frequency_interval)?.split(",")?.map((value: string | number) => TIME_TEXT[value])?.join(",");
    // 每天
    case 4: {
      const {freqTime} =  getDayWeekMonth(record,false,true)
      return `${formatMessage({id: "subscribe_manager_frequency_everyday"})} ${freqTime?.substring(0, 5)}`;
    }
    // 每周
    case 5: {
      const {freqDay} =  getDayWeekMonth(record,false,true)
      const interval = freqDay?.split(",")?.map((num: string | number) => WEEK_TEXT[num])?.join(",")
      return interval
    }
    // 每月
    case 6: {
      const local = getLocale();
      const {freqDay} =  getDayWeekMonth(record,true,true)
      const interval = freqDay?.split(",")?.map((num: any) => {

        return local === 'en-US' ? num : `${num}号`
      })?.join(",")
      return `${formatMessage({id: 'subscribe_manager_frequency_every_month'})} ${interval}`
    }
    default: return "-"
  }
}
